var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';


import { UserRole } from "../../../shared/types/userSchema";


import { UserList } from "./UserList";
import { loadUsers, saveUser, deleteUser, newUser } from "../actions/actions";
import { loadUserGroups } from "./usergroups/actions/actions";
import { UserSidePanel } from "./UserSidePanel";

import { reset2fa } from "../../Auth2fa/actions/actions";
import { recoverPassword } from "../../Auth/actions";












const UsersComponent = ({
  users,
  userGroups,
  loadUsers: loadAllUsers,
  loadUserGroups: loadAllGroups,
  newUser: createUser,
  saveUser: saveUserData,
  deleteUser: deleteUserData,
  reset2fa: resetTwoFactorAuth,
  recoverPassword: resetUserPassword
}) => {var _selectedUser$_id;
  const userList = users ? users.toJS() : [];
  const userGroupList = userGroups ? userGroups.toJS() : [];
  const [selectedUser, setSelectedUser] = useState();
  const [sidePanelOpened, setSidePanelOpened] = useState(false);

  useEffect(() => {
    if (userList.length === 0) {
      loadAllUsers().
      then().
      catch(() => {});
    }
    if (loadAllGroups.length === 0) {
      loadAllGroups().
      then().
      catch(() => {});
    }
  }, []);

  const closeSidePanel = () => {
    setSelectedUser(undefined);
    setSidePanelOpened(false);
  };

  const handlers = {
    handleSelect: (user) => {
      setSelectedUser(user);
      setSidePanelOpened(true);
    },

    handleSave: async (user) => {
      if (!user.password) {
        delete user.password;
      }
      delete user.using2fa;
      if (user._id) {
        await saveUserData(user);
      } else {
        delete user._id;
        await createUser(user);
      }
      await loadAllGroups();
      closeSidePanel();
    },

    handleDelete: async (user) => {
      await deleteUserData({ _id: user._id });
      closeSidePanel();
    },

    handleAddUser: () => {
      setSelectedUser({ role: UserRole.COLLABORATOR, username: '', email: '' });
      setSidePanelOpened(true);
    },

    handleResetPassword: async (user) => {
      await resetUserPassword(user.email);
    }
  };

  return /*#__PURE__*/(
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx(UserList, {
      users: userList,
      handleSelect: handlers.handleSelect,
      handleAddUser: handlers.handleAddUser,
      className: sidePanelOpened ? 'with-sidepanel' : '' }),

    selectedUser && /*#__PURE__*/
    _jsx(UserSidePanel, {

      opened: sidePanelOpened,
      user: selectedUser,
      users: userList,
      groups: userGroupList,
      onSave: handlers.handleSave,
      onDelete: handlers.handleDelete,
      onReset2fa: resetTwoFactorAuth,
      closePanel: closeSidePanel,
      onResetPassword: handlers.handleResetPassword }, (_selectedUser$_id = selectedUser._id) === null || _selectedUser$_id === void 0 ? void 0 : _selectedUser$_id.toString())));




};

const mapStateToProps = (state) => ({
  users: state.users,
  userGroups: state.userGroups
});

const mapDispatchToProps = {
  loadUsers,
  newUser,
  saveUser,
  deleteUser,
  loadUserGroups,
  reset2fa,
  recoverPassword
};


export const Users = connect(mapStateToProps, mapDispatchToProps)(UsersComponent);